import {useTranslation} from 'react-i18next';

import NodeEditorLayout from '../NodeEditorLayout';
import {NodeEditorV2Props} from '../types';

/** AFTER_EVERYONE ("Wait for everyone"): nothing to configure; the dialog edits the label and explains the step. */
const AfterEveryoneEditorV2 = (_props: NodeEditorV2Props) => {
    const {t} = useTranslation();

    return (
        <NodeEditorLayout
            state={'configured'}
            summary={[
                t('Every run above ends here. The automation waits until all of them have finished, then the steps below run once.'),
                t('A summary below can use the member counts of this step: how many were handled and how many failed.')
            ].join(' ')}
        >
            {null}
        </NodeEditorLayout>
    );
};

export default AfterEveryoneEditorV2;
